import { login, getInfo, logout, getUserMenuPower } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter, constant } from "@/router";
import role from "@/router/index";
const state = {
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  buttons: [],
  buttonName: [],
  cardTypeDice: [
    { label: "全部", value: null },
    { label: "大陆居民身份证", value: 1 },
    { label: "护照", value: 2 },
    { label: "香港居民往来内地通行证", value: 3 },
    { label: "澳门居民往来内地通行证", value: 4 },
    { label: "台湾居民往来内地通行证", value: 5 }
  ],
  payType: 1,
  agreementId: "",
  showNotice: false,
  id: "",
  taxId: "",
  menuList: [],
  parentList: [],
  agreement: {},
  // 隐藏数据的后门（杨小新）backdoor
  isHidden: false,
  manageDetail: {}, //任务管理考勤参数缓存

  isModuleSign: null, //1服务商签约 2 岗位签约
  reportingType: [], // 人员报送信息类型
  outTradeChannelConfig: null // 外部税地配置信息
};
const mutations = {
  SET_MID: (state, mId) => {
    state.mId = mId;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_BUTTONS: (state, buttons) => {
    state.buttons = buttons;
  },
  SET_BUTTO_NAME: (state, buttonName) => {
    state.buttonName = buttonName;
  },
  SET_ID: (state, id) => {
    state.id = id;
  },
  SET_MENU_LIST: (state, menuList) => {
    state.menuList = menuList;
  },
  SET_PARENT_LIST: (state, parentList) => {
    state.parentList = parentList;
  },
  SET_TAX_ID: (state, taxId) => {
    state.taxId = taxId;
  },
  SET_AREEMENT: (state, agreement) => {
    state.agreement = agreement;
  },

  SET_MUDULESIGN: (state, signType) => {
    state.isModuleSign = signType;
  },

  SET_REPORTING_TYPE: (state, list) => {
    state.reportingType = list;
  },

  SET_OUT_TRADE_CHANNEL_CONFIG: (state, outTradeChannelConfig) => {
    state.outTradeChannelConfig = outTradeChannelConfig;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then(response => {
          const { data } = response;
          this.state.user.agreementId = data.agreementId;
          localStorage.setItem("merchantName", data.merchantName);
          localStorage.setItem("taxSourceName", data.taxSourceName);
          localStorage.setItem("agreementType", data.agreementType);
          localStorage.setItem("agreementId", data.agreementId);
          localStorage.setItem("payPhone", data.payPhone);
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          localStorage.setItem("roleIsLogin", 1);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      const roles = role.options.routes;
      commit("SET_ROLES", roles);
      // resolve({})

      getInfo({ agreementId: localStorage.getItem("agreementId") })
        .then(async res => {
          if (res.data.outApiConfig) {
            commit("SET_OUT_TRADE_CHANNEL_CONFIG", res.data.outTradeChannelConfig);
          }
          commit("SET_AREEMENT", res.data);
          // 隐藏数据后门（backdoor）
          if (localStorage.getItem("fName") === "18923547229" && localStorage.getItem("agreementId") === "40003646") {
            this.state.user.isHidden = true;
          }

          if (!res.data.signModeC) {
            commit("SET_MUDULESIGN", 0); // C端业务模式【0-服务商签约，1-岗位签约】
          } else {
            commit("SET_MUDULESIGN", res.data.signModeC); // C端业务模式【0-服务商签约，1-岗位签约】
          }

          if (res.data.staffTaxFilingDefaultType) {
            let arr = [];
            let staffTaxFilingEnums = res.data.staffTaxFilingEnums;
            let list = res.data.staffTaxFilingDefaultType || [];
            list = list.split(",");
            list.forEach(item => {
              staffTaxFilingEnums.forEach(item2 => {
                if (item2.name === item) {
                  arr.push(item2);
                }
              });
            });

            if (!res.data.signModeC) {
              commit("SET_REPORTING_TYPE", arr);
            } else {
              commit("SET_REPORTING_TYPE", res.data.staffTaxFilingEnums);
            }
          }

          commit("SET_TAX_ID", res.data.taxId);
          //   安全发充值方式【0-银行划拨，1-签约授权】
          localStorage.setItem("alisafeRechargeType", res.data.alisafeRechargeType);
          localStorage.setItem("paymentType", res.data.paymentType);
          // 签约人员按钮隐藏
          localStorage.setItem("userModel", res.data.userModel);
          localStorage.setItem("apiSwitch", res.data.apiSwitch);
          localStorage.setItem("payPhone", res.data.payPhone);
          const val = res.data.payType || "1";
          localStorage.setItem("payType", val);
          localStorage.setItem("taxSourceName", res.data.taxSourceName);
          localStorage.setItem("merchantName", res.data.merchantName);
          localStorage.setItem("isPreInvoicing", res.data.isPreInvoicing);
          localStorage.setItem("taskSettlement", res.data.taskSettlement);
          localStorage.setItem("showServiceFee", res.data.showServiceFee);
          localStorage.setItem("signNeedTemplate", res.data.signNeedTemplate);
          localStorage.setItem("signNeedArea", res.data.signNeedArea);
          localStorage.setItem("beiSenOutApiConfig", res.data.outApiConfig);
          localStorage.setItem("staffTaxFilingDefaultType", res.data.staffTaxFilingDefaultType);

          let roles = role.options.routes;

          for (let i = 0; i < roles.length; i++) {
            roles[i].meta.allow = constant[i].meta.allow;
            roles[i].hidden = constant[i].hidden;
            if (roles[i].children) {
              for (let m = 0; m < roles[i].children.length; m++) {
                roles[i].children[m].meta.allow = constant[i].children[m].meta.allow;
                roles[i].children[m].hidden = constant[i].children[m].hidden;
              }
            }
          }

          const { data } = await getUserMenuPower();

          let list = data.menuList;
          console.log(list, "list");

          list = list.filter(role => {
            // 派单模式不展示新业态 新业态模式不展示派单
            if (state.agreement.businessModel) {
              return role.fpath !== "/sendOrders";
            } else {
              return role.fpath !== "/newBusiness";
            }
          });
          // 是否展示常规任务
          if (!state.agreement.routineTaskOpen) {
            list = list.filter(role => {
              return role.fpath !== "/task";
            });
          }
          const parentList = data.catalogList || [];
          //   北森后门（backdoor）
          if (res.data.outApiConfig === "NBM_OUT") {
            list.push({
              fpath: "/newBusiness",
              path: "scheduling"
            });
            list.push({
              fpath: "/newBusiness",
              path: "beisenSettlement"
            });
            list.push({
              fpath: "/newBusiness",
              path: "resignation"
            });
            list.push({
              fpath: "/newBusiness",
              path: "attendanceReview"
            });
            list.push({
              fpath: "/newBusiness",
              path: "storeTransfer"
            });
          }

          // 后门处理列表（backdoor）
          if (localStorage.getItem("fName") === "18923547229" && localStorage.getItem("agreementId") === "40003646") {
            const item = list.find(item => item.path === "apiDistribution");
            if (item) list.splice(list.indexOf(item), 1);
            const item1 = list.find(item => item.path === "downloadCenter");
            if (item1) list.splice(list.indexOf(item1), 1);
            const item2 = list.find(item => item.path === "userManage");
            if (item2) list.splice(list.indexOf(item2), 1);
          }

          let redirect = false;
          for (let i = 0; i < roles.length; i++) {
            for (let n = 0; n < list.length; n++) {
              if (roles[i].path === list[n].fpath) {
                roles[i].meta.allow = true;
                const parent = parentList.filter(item => {
                  return item.path === list[n].fpath;
                });
                if (roles[i].meta.title && parent.length) {
                  roles[i].meta.title = parent[0].label;
                }
                for (let m = 0; m < roles[i].children.length; m++) {
                  const lowPath = roles[i].children[m].path.split("/")[0];
                  if (lowPath === list[n].path) {
                    roles[i].children[m].meta.allow = true;
                    if (list[n].label) roles[i].children[m].meta.title = roles[i].children[m].meta.title || list[n].label;
                    if (localStorage.getItem("roleIsLogin") === "1" && roles[i].children[m].path.split("/").length === 1) {
                      redirect = { path: (roles[i].path === "/" ? "" : roles[i].path) + "/" + roles[i].children[m].path };
                      localStorage.setItem("roleIsLogin", 0);
                    }
                  }
                }
              }
            }
          }
          for (let i = 0; i < roles.length; i++) {
            if (roles[i].children) {
              let num = 0;
              for (let m = 0; m < roles[i].children.length; m++) {
                if (!roles[i].children[m].meta.allow) {
                  roles[i].children[m].hidden = true;
                  num++;
                }
              }
              if (num === roles[i].children.length) {
                roles[i].hidden = true;
              }
            }
          }

          //  人员管理目录下   人岗合同和人企合同 根据商户协议 是否签署 服务商签约  还是岗位签约 然后根据这个去过滤 是显示人岗合同 还是人企合同
          //  去筛选这个数据 去除底部的children
          roles.forEach(role => {
            if (role.path === "/flexibleuser" && Array.isArray(role.children) && role.children.length) {
              role.children = role.children.filter(child => {
                console.log("child", child);

                if (state.isModuleSign === 0) {
                  return child.path !== "personPost";
                }
                return child.path !== "PersonCompany";
              });
            }
          });
          // button权限
          const buttonAuthList = data.buttonList;
          const buttonNameList = data.buttonNameList;
          // 北森后门（backdoor）
          if (res.data.outApiConfig === "NBM_OUT") {
            buttonAuthList.push("flexibleuser:index:nbm");
            buttonAuthList.push("newBusiness:staffPost:nbm");
            buttonAuthList.push("newBusiness:settlementCenter:nbm");
            buttonAuthList.push("newBusiness:storeManage:nbm");
            buttonAuthList.push("newBusiness:recruiting:manage:nbm");
            buttonAuthList.push("newBusiness:storeTransfer:nbm");
            // 批次订单去支付
            buttonAuthList.push("distribution:apiDistribution:nbm");
            // BtnList组件添加后门
            buttonNameList.push({
              apiPower: "newBusiness:storeTransfer:nbm",
              fpath: null,
              label: "导出",
              path: "newBusiness:storeTransfer:nbm"
            });
          }
          commit("SET_MENU_LIST", list);
          commit("SET_ID", data.id);
          commit("SET_ROLES", roles);
          commit("SET_BUTTONS", buttonAuthList);
          commit("SET_BUTTO_NAME", buttonNameList);
          commit("SET_PARENT_LIST", parentList);
          resolve({ roles: JSON.stringify(roles), redirect: redirect });
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  // user logout
  logout({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          commit("SET_BUTTONS", []);
          commit("SET_PARENT_LIST", []);
          removeToken();
          resetRouter();

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485

          dispatch("tagsView/delAllViews", null, { root: true });
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_MID", "");
      commit("SET_ROLES", []);
      commit("SET_BUTTONS", []);
      commit("SET_PARENT_LIST", []);
      removeToken();
      resolve();
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + "-token";

    commit("SET_TOKEN", token);
    setToken(token);

    const { roles } = await dispatch("getInfo");

    resetRouter();

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch("permission/generateRoutes", roles, { root: true });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch("tagsView/delAllViews", null, { root: true });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
